import {agentRequest} from '../services/request';
import {agentEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';

const {getUrl} = apiHelpers;

const errorHandlerProps = {disableAlert: true};

const createCompanyPolicy = ({data, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.post({
      dispatch,
      url: agentEndpoints.POST_CREATE_COMPANY_POLICY,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getCompanyPolicies = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    agentRequest.get({
      dispatch,
      url: agentEndpoints.GET_COMPANY_POLICIES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateCompanyPolicy = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.patch({
      dispatch,
      url: getUrl(agentEndpoints.PATCH_UPDATE_COMPANY_POLICY, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

export const agentActions = {
  createCompanyPolicy,
  getCompanyPolicies,
  updateCompanyPolicy,
};
